export const webglPlayerBaseUrl = `${process.env.REACT_APP_WEBGL_BUCKET_URL}/6241384b-e280-40a5-8f0f-8cec7fdc25a2`;

const PLAYER_VERSION_KEY = "__arbookQuizPlayerVersionPromise__";
type PlayerVersionWindow = Window & {
  [PLAYER_VERSION_KEY]?: Promise<string>;
};

const fallbackVersion = () => new Date().toISOString().slice(0, 10);

export const getPlayerVersion = (): Promise<string> => {
  if (typeof window === "undefined") {
    return Promise.resolve(fallbackVersion());
  }
  const store = window as PlayerVersionWindow;
  if (!store[PLAYER_VERSION_KEY]) {
    store[PLAYER_VERSION_KEY] = fetch(
      `${webglPlayerBaseUrl}/version.json?t=${Date.now()}`,
      {
        cache: "no-store",
      },
    )
      .then(response => (response.ok ? response.json() : Promise.reject()))
      .then(data => {
        const raw = data?.version;
        const value =
          typeof raw === "string" || typeof raw === "number"
            ? String(raw).trim()
            : "";
        return value || Promise.reject();
      })
      .catch(() => {
        delete store[PLAYER_VERSION_KEY];
        return fallbackVersion();
      });
  }
  return store[PLAYER_VERSION_KEY] as Promise<string>;
};
